import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { AppConfigService } from './base/app-config.service';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private apiBaseUrl: string = AppConfigService.settings.apiUrl;
  private facilityId = localStorage.getItem('current_facility_id') || 'ES';

  constructor(private http: HttpClient, private rest: RestService) {
    this.apiBaseUrl = AppConfigService.settings.apiUrl;
  }
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }
  getFilterListData(): Observable<any> {
    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetStatusReportBuildSearch?facilityId=` + this.facilityId + `&IsRetired=false`).pipe(
      catchError(error => {
        
        // Return empty array instead of throwing an error
        // This allows the component to render with static data
        return throwError(() => error);
      })
    );
  }
  getTlrStatusReport(isOldUser: boolean, payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}TLRStatus/GetTlrStatusReport?isOldUser=` + isOldUser, payload).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }
  GetInstalledTLRStatusReport(isOldUser: boolean, payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}TLRStatus/GetInstalledTLRStatusReport?isOldUser=` + isOldUser, payload).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }

  getTlrStatusReportDetails(isOldUser: boolean, payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}TLRStatus/GetTLRStatusReportDetails?isOldUser=` + isOldUser, payload).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }




  // added by Nirmal on 10/12/2023 for TLR status report
  //Orphon Report
  getTlrOrphanReport(facilityId: string, userCAI: string): any {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();

    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLROrphanReport?facilityId=${currentFacilityId}`).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }


  // On Run Report
  GetTlrOnRunReport(facilityId: string, userCAI: string): any {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();

    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLROnRunReport?facilityId=${currentFacilityId}`).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }


  // steam buster  Report
  GetTlrSteamBusterReport(facilityId: string, userCAI: string): any {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();

    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLRSteamBusterReport?facilityId=${currentFacilityId}`).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }


  // steam buster  Report
  GetTlrAbandonedServiceReport(facilityId: string, userCAI: string): any {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();

    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLRAbandonedServiceReport?facilityId=${currentFacilityId}`).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }

  // added by Nirmal on 10/12/2023 ended

  GetInstalledTLRStatusReportDetails(isOldUser: boolean, payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}TLRStatus/GetInstalledTLRStatusReportDetails?isOldUser=` + isOldUser, payload).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }


  GetTlrOrphanReportExcel(p: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLROrphanReportExcel`, p);
  }


  GetTlrOnRunReportExcel(p: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTlrOnRunReportExcel`, p);
  }


  GetTlrSteamBusterReportExcel(p: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLRSteamBusterReportExcel`, p);
  }

  GetTlrAbandonedServiceReportExcel(p: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLRAbandonedServiceReportExcel`, p);
  }
  getTlrRemovedStatusReport(payload: any): Observable<any> {
    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLRRemovedStatusReport?facilityId=` + this.facilityId + `&graphFlag=` + payload.graphFlag + `&userCAI=` + payload.userCai + `&startDate=` + payload.startDate + `&endDate=` + payload.endDate + `&sectionName=` + payload.sectionName).pipe(
      catchError(error => {
        // Return empty array instead of throwing an error
        // This allows the component to render with static data
        return throwError(() => error);
      })
    );
  }
  GetTLRRemovedStatusReportExcel(payload: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLRRemovedStatusReportExcel?facilityId=` + this.facilityId + `&userCAI=` + payload.userCai + `&startDate=` + payload.startDate + `&endDate=` + payload.endDate + `&sectionName=` + payload.sectionName, {});
  }
  GetInstalledTLRStatusReportDetailsExcel(isOldUser: boolean, payload: any): Observable<any> {
    return this.rest.downloadPost(`TLRStatus/GetInstalledTLRStatusReportDetailsExcel?isOldUser=` + isOldUser, payload);
  }
  getTlrstatusReportDetailsExportExcel(payload: any): Observable<any> {
    return this.rest.downloadPost(`TLRStatus/GetTLRStatusReportDetailsExcel`, payload);
  }
  getTLRBeyondDateReport(payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}TLRStatus/GetTLRBeyondDueDateReport`, payload).pipe(
      catchError(error => {
        // Return empty array instead of throwing an error
        // This allows the component to render with static data
        return throwError(() => error);
      })
    );
  }
  getTlrBeyondDueDateDetailsExportExcel(payload: any): Observable<any> {
    return this.rest.downloadPost(`TLRStatus/GetTLRBeyondDueDateReportExcel`, payload);
  }


  // added by Nirmal on 10/12/2023 for TLR breakdoen report

  GetTlrBreakDownReport(payload:any): any {
    return this.http.get(`${this.apiBaseUrl}TLRStatus/GetTLRBreakDownReport?facilityId=${payload.facility}&graphFlag=${payload.graphFlag}&sectionName=${payload.sectionName}`).pipe(
      catchError(error => {
        
        return throwError(() => error);
      })
    )
  }
  // break down el
  GetTlrBreakDownReportExcel(payload: any): Observable<any> {
    return this.rest.download(`TLRStatus/GetTLRBreakDownReportExcel?facilityId=${payload.facility}&graphFlag=${payload.graphFlag}&sectionName=${payload.sectionName}`, {});
  }

}
